import { ProductDepartmentCreatePage } from "@/features/product-department/pages/ProductDepartmentCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-department/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_department.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductDepartmentCreatePage,
});
